module.exports = __webpack_public_path__ + "static/media/cq_nuovo_documento b.c0f2df87.svg";